module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PhysicalCardView.js"));
	}, "PhysicalCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PhysicalCardView!./src/pages/Register/PhysicalCard/PhysicalCardView.js
// module id = 837
// module chunks = 431